import React, { FunctionComponent, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import Button from '../../UI/Button';
import Icon from '../../Icons';
import { parsePrice, getDateFromTimeInSec } from '../../../utils/utils';
import { addMoney } from '../promiseAction';
import { setMoney } from '../action';

import { Container } from './styles';

const getStatusClass: any = {
  SUCCESS: 'Successful',
  PENDING: 'Pending',
  FAILURE: 'Failed',
};

const getStatusIcon: any = {
  SUCCESS: 'success',
  PENDING: 'pending',
  FAILURE: 'failure',
};

interface Props {
  status: string;
  statusRemarks?: string;
  amount: number;
  timestamp: number;
  currency: string;
  remarksIcon?: string;
  date: number;
}

const PaymentResponse: FunctionComponent<{ data: Props }> = ({ data }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [error, setError] = useState('');

  const dispatchToStore = useCallback(
    (payload: any) =>
      dispatch(addMoney({ amount: payload.retry })).then((resp: any) => {
        if (resp.data.success) {
          dispatch(setMoney(resp.data));
          history.push('/portal/payment');
        } else {
          payload.retry++;
          if (payload.retry < 4) {
            dispatchToStore({
              amount: parseFloat(payload.amount),
              retry: payload.retry,
            });
          } else {
            setError('Something went wrong. Please try again.');
          }
        }
      }),
    // TODO: handle dependencies history
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch],
  );

  const retryPayment = (amount: number) => {
    setError('');
    let retry = 1;
    dispatchToStore({
      amount,
      retry,
    });
  };

  const handleClose = () => {
    const referralUrl = localStorage.getItem('referralUrl');
    localStorage.setItem('referralUrl', '');
    if (referralUrl) {
      history.push(referralUrl);
    } else {
      history.push('/');
    }
  };

  const { status, statusRemarks, amount, currency, date, remarksIcon } = data;
  return (
    <div className="flex justify-content-c flex-dir-c falign-c mt24">
      <Container className="bg-white text-center">
        <div
          className={`${
            getStatusClass[status] ? getStatusClass[status].toLowerCase() : ''
          } status-icon flex justify-content-c falign-c`}
        >
          <Icon name={getStatusIcon[status]} path="payment" />
        </div>
        <p className="fwb mt24 largest">Payment {getStatusClass[status] || status}</p>
        {status !== 'SUCCESS' && remarksIcon ? <p className="mt16">{statusRemarks}</p> : null}

        <p className="mt16">{parsePrice({ price: amount, currency })}</p>
        <p className="mt8 font-light-grey small">{getDateFromTimeInSec(date)}</p>
        {status === 'FAILURE' && !remarksIcon ? (
          <p className={`${getStatusClass[status].toLowerCase()} failed notification mt16`}>{statusRemarks}</p>
        ) : null}
        {status === 'PENDING' && !remarksIcon ? (
          <p className={`${getStatusClass[status].toLowerCase()} pending notification mt16`}>{statusRemarks}</p>
        ) : null}

        {remarksIcon ? (
          <div className="mt16 error-img">
            <img src={remarksIcon} alt={status} />
          </div>
        ) : null}

        {status === 'SUCCESS' ? (
          <div className="mt16 wfull">
            <Button
              color="#304ffe"
              style={{ width: '100%', height: '40px' }}
              variant="contained"
              clickHandler={handleClose}
            >
              Close
            </Button>
          </div>
        ) : (
          <div className="mt16 wfull">
            <Button
              color="#304ffe"
              style={{ width: '100%', height: '40px' }}
              variant="contained"
              clickHandler={() => retryPayment(amount)}
            >
              Retry
            </Button>
          </div>
        )}
        <p className={`small font-red mt8 ${error ? '' : 'none'}`}>{error}</p>
      </Container>
    </div>
  );
};

export default PaymentResponse;
